import Logger from "../Logger";
import BaseModel from "./BaseModel";
const logger = new Logger();

export default class ObjectFactory {
  static allClasses = new Map<string, (data?: any, parent?: BaseModel) => BaseModel>();

  static registerClass(
    className: string,
    itemClassCreator: (data?: any, parent?: BaseModel) => BaseModel,
  ): () => BaseModel {
    ObjectFactory.allClasses.set(className, itemClassCreator);
    return itemClassCreator;
  }

  static createObject(className: string, data?: any, parent?: BaseModel): BaseModel | undefined {
    const creator = ObjectFactory.allClasses.get(className);
    if (creator) {
      return creator(data, parent);
    } else {
      logger.error(`createObject: className ${className} not registered`);
      return undefined;
    }
  }
}
